export default {
	"pages": {
		"root": {
			"id": "root",
			"pageUrl": "root",
			"name": "root",
			"children": [
				"657f8e4c009abe001f00aea4",
				"657f8e4c009abe001f00aea8"
			]
		},
		"657f8e4c009abe001f00aea4": {
			"id": "657f8e4c009abe001f00aea4",
			"name": "404",
			"pageUrl": "404"
		},
		"657f8e4c009abe001f00aea8": {
			"id": "657f8e4c009abe001f00aea8",
			"name": "index",
			"pageUrl": "index"
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {},
		"seo": {
			"favicon_apple_152px": "https://uploads.quarkly.io/6123949e957019001e284458/images/favicon152.svg?v=2021-09-21T16:17:59.502Z",
			"favicon_32px": "https://uploads.quarkly.io/6123949e957019001e284458/images/favicon.svg?v=2021-09-21T16:18:29.306Z",
			"favicon_win10_270px": "https://uploads.quarkly.io/6123949e957019001e284458/images/favicon270.svg?v=2021-09-21T16:18:07.731Z",
			"background_win10": "#000848",
			"og:title": "Help for you — Healthcare without the system",
			"og:description": "Chat with a doctor right from your phone, all day and night. No waiting room or appointment needed.",
			"og:image": "https://uploads.quarkly.io/6123949e957019001e284458/images/OGimage.png?v=2021-09-21T16:25:40.647Z",
			"title": "Help for you — Healthcare without the system",
			"description": "Chat with a doctor right from your phone, all day and night. No waiting room or appointment needed."
		}
	}
}